module.exports = __webpack_public_path__ + "static/media/tableuparrow.79ca89cf.svg";